export default {
    computed: {
        getTransportType () {
            return [
                {
                    value: 0,
                    label: "快船"
                },
                {
                    value: 1,
                    label: "普船"
                },
                {
                    value: 2,
                    label: "空运"
                },
                {
                    value: 3,
                    label: "快递"
                }
            ]
        },
    }
};